import {FkBaseAttribute, type FkBaseAttributeOptions} from './FkBaseAttribute';
import {fkModel} from '../../../../models/hit/modelRegistry';

/**
 * FK attribute classes. Model classes are resolved lazily via {@link fkModel}
 * so that Model -> attributes -> FkEntityAttribute -> Model does not TDZ.
 */

export class FkAccountAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('GeneralAccount'));
  }
}

export class FkActionAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Action'));
  }
}

export class FkAlertDefinitionAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('AlertDefinition'));
  }
}

export class FkActivityAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Activity'));
  }
}

export class FkAddressAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Address'));
  }
}

export class FkAddressCommunicationModeAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('AddressCommunicationMode'));
  }
}

export class FkAddressBankAccountAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('AddressBankAccount'));
  }
}

export class FkContactAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Contact'));
  }
}

export class FkCostAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Cost'));
  }
}

export class FkCostItemAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('CostItem'));
  }
}

export class FkCountryAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Country'));
  }
}

export class FkDayTypeAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('DayType'));
  }
}

export class FkDueDateAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('DueDate'));
  }
}

export class FkEquipmentAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Equipment'));
  }
}

export class FkEquipmentMaintenanceAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('EquipmentMaintenance'));
  }
}

export class FkFileDocumentAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('FileDocument'));
  }
}

export class FkFormAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Form'));
  }
}

export class FkFormDefinitionAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('FormDefinitionNew'));
  }
}

export class FkIdentifierSchemeAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('IdentifierScheme'));
  }
}

export class FkItemDataAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('ItemData'));
  }
}

export class FkTransactionAccountAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('TransactionAccount'));
  }
}

export class FkJournalAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Journal'));
  }
}

export class FkPeriodAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Period'));
  }
}

export class FkPositionItemAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('PositionItem'));
  }
}

export class FkProjectAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Project'));
  }
}

export class FkProjectPartAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('ProjectPart'));
  }
}

export class FkProjectPartIndexAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('ProjectPartIndex'));
  }
}

export class FkPurchaseAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Purchase'));
  }
}

export class FkPurchaseSupplierAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('PurchaseSupplier'));
  }
}

export class FkQmDocumentAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('QmDocument'));
  }
}

export class FkQmDocumentHistoryAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('QmDocumentHistory'));
  }
}

export class FkQmSubjectAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('QmSubject'));
  }
}

export class FkQmSystemAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('QmSystem'));
  }
}

export class FkQualificationAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Qualification'));
  }
}

export class FkResourceAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Resource'));
  }
}

export class FkResourceCategoryAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('ResourceCategory'));
  }
}

export class FkResourceClassificationAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('ResourceClassification'));
  }
}

export class FkStaffAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Staff'));
  }
}

export class FkStaffCompensationTypeAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('StaffCompensationType'));
  }
}

export class FkStockAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Stock'));
  }
}

export class FkCompetenceAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Competence'));
  }
}

export class FkStaffCommunicationModeAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('StaffCommunicationMode'));
  }
}

export class FkTaxCodeAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('TaxCode'));
  }
}

export class FkTransactionAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Transaction'));
  }
}

export class FkTransactionItemAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('TransactionItem'));
  }
}

export class FkUnitAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('Unit'));
  }
}

export class FkTrackerCustomerAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('TrackerCustomer'));
  }
}

export class FkProjectContractAttribute extends FkBaseAttribute {
  constructor(options: FkBaseAttributeOptions = {}) {
    super(options, fkModel('ProjectContract'));
  }
}
